<template>
  <b-row>
    <b-col :md="4">
      <b-card class="statistics__card">
        <div>
          <DisplayCategoryMessage :data="totalInfo.totalYoungs" text="Nombre de personnes" icon="UserIcon" />
          <div class="sub-category">
            <DisplayCategoryMessage :data="totalInfo.totalExistingYoungs" text="Personne déjà connues" icon="CornerDownRightIcon" />
            <DisplayCategoryMessage :data="totalInfo.totalNewYoungs" text="Nouvelles fiches créées" icon="CornerDownRightIcon" />
            <div class="sub-sub-category">
              <DisplayCategoryMessage :data="totalInfo.totalNewYoungsWithAccommodation" text="Nouvelles demande d'hébergement 18/25" icon="CornerDownRightIcon" />
            </div>
          </div>
          <DisplayCategoryMessage :data="callDurantionAvarage" text="Moyenne des appels" icon="SmartphoneIcon" />
          <DisplayCategoryMessage :data="totalInfo.callReceived" text="Appels reçus" icon="SmartphoneIcon" />
          <div class="sub-category">
            <DisplayCategoryMessage :data="totalInfo.callReceivedAnswered" text="Appels reçus répondus" icon="CornerDownRightIcon" />
            <div class="sub-sub-category">
              <DisplayCategoryMessage :data="totalInfo.callReceivedAnsweredFromUniqueYoungs" text="Personnes distinctes concernées" icon="CornerDownRightIcon" />
            </div>
            <DisplayCategoryMessage :data="totalInfo.callReceivedUnanswered" text="Appels reçus non répondus" icon="CornerDownRightIcon" />
            <div class="sub-sub-category">
              <DisplayCategoryMessage :data="totalInfo.callReceivedUnansweredFromUniqueYoungs" text="Personnes distinctes concernées" icon="CornerDownRightIcon" />
            </div>
          </div>
          <DisplayCategoryMessage :data="totalInfo.callEmitted" text="Appels émis" icon="SmartphoneIcon" />
          <div class="sub-category">
            <DisplayCategoryMessage :data="totalInfo.callEmittedFromUniqueYoungs" text="Personnes distinctes concernées" icon="CornerDownRightIcon" />
          </div>
          <DisplayCategoryMessage :data="totalInfo.totalYoungsNotContactedBack" text="Jeunes sans retour de la Fondation" icon="PhoneMissedIcon" />
          <DisplayCategoryMessage :data="totalInfo.smsReceived" text="Sms reçus" icon="MessageSquareIcon" />
          <DisplayCategoryMessage :data="totalInfo.smsEmitted" text="Sms émis (hors Whatsapp)" icon="MessageSquareIcon" />
          <DisplayCategoryMessage :data="totalInfo.whatsAppReceived" text="Whatsapp reçus" icon="MessageCircleIcon" />
          <DisplayCategoryMessage :data="totalInfo.whatsAppEmitted" text="Whatsapp émis" icon="MessageCircleIcon" />
        </div>
      </b-card>
    </b-col>
    <b-col :md="4">
      <chartjs-container :title="barChartName">
        <chartjs-component-bar-chart :height="chartHeight" :chart-data="chartData" />
      </chartjs-container>
    </b-col>
    <b-col :md="4">
      <chartjs-container :title="pieChartName">
        <chartjs-component-pie-chart v-if="pieHasMeaningfulData" :height="chartHeight" :chart-data="pieData"
                                     :chart-tooltips="tooltips" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'
import ChartjsComponentPieChart from '../charts-components/ChartjsComponentPieChart.vue'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentBarChart from '../charts-components/ChartjsComponentBarChart.vue'
import DisplayCategoryMessage from '../displayCategoryMessage.vue'
import {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  chartHasMeaningfulData,
  CHART_COLORS,
  TABS,
} from './baseConfiguration'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'

export default {
  components: {
    BCard,
    BCol,
    BRow,
    ChartjsContainer,
    DisplayCategoryMessage,
    ChartjsComponentPieChart,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      tooltips: {
        enabled: true,
        callbacks: {
          label: (tooltipValue, data) => {
            const numericValue = data.datasets[0].data[tooltipValue.index]
            const total = data.datasets[0].data.reduce((acc, curr) => acc + curr, 0)
            const percentage = Math.round((numericValue / total) * 100)
            return `Demandes: ${numericValue} - Pourcentage: ${percentage} %`
          },
        },
      },
      tabname: TABS.CALLS,
      totalInfo: {},
      statsInfo: [],
      chartLabel: [],
      barChartName: 'Statistiques des appels',
      pieChartName: 'Type de demande',
      pieData: {},
      chartHeight: BASE_CHART_HEIGHT,
    }
  },
  computed: {
    callDurantionAvarage() {
      return Math.round(this.totalInfo.callDurantionAvarage * 100) / 100
    },
    chartData() {
      return {
        labels: this.chartLabel,
        datasets: this.statsInfo,
      }
    },
    pieHasMeaningfulData() {
      return chartHasMeaningfulData(this.pieData)
    },
    ...computedConfiguration,
  },
  watch: watchConfiguration,
  methods: {
    async fetchRouteOnActive() {
      if (this.active) {
        const response = await useStatisticsRouteFetch()
        this.totalInfo = response
        this.constructBarChartObj(response)
        this.formatPieData(response.demandType)
      }
    },
    constructBarChartObj(response) {
      const labels = {
        'Appels reçus': response.callReceived,
        'Appels reçus répondus': response.callReceivedAnswered,
        'Appels reçus non répondus': response.callReceivedUnanswered,
        'Appels émis': response.callEmitted,
        'SMS reçu': response.smsReceived,
        'Sms émis': response.smsEmitted,
        'WhatsApp reçus': response.whatsAppReceived,
        'WhatsApp émis': response.whatsAppEmitted,
      }
      this.chartLabel = ['Type de communication']
      this.statsInfo = this.formatData(labels)
    },
    formatData(labels) {
      const labelKeys = Object.keys(labels)
      return labelKeys.map((label, index) => ({
        label,
        data: [labels[label]],
        backgroundColor: CHART_COLORS.PRIMARY[index % CHART_COLORS.PRIMARY.length],
        barThickness: 20,
      }))
    },
    formatPieData(data) {
      this.pieData = {
        labels: data.map(demand => demand.label),
        datasets: [
          {
            backgroundColor: CHART_COLORS.PRIMARY,
            data: data.map(demand => demand.value),
          },
        ],
      }
    },
  },
}
</script>

<style>
p {
  font-size: 1rem;
}

svg {
  width: 1.7em;
  height: 1.7em;
  vertical-align: middle;
}

.sub-category {
  padding-left: 20px;
  margin-left: 10px;
}

.sub-sub-category {
  padding-left: 10px;
  margin-left: 10px;
}

.sub-sub-category p {
  font-size: 0.9rem;
}

.sub-sub-category svg {
  width: 1em;
  height: 1em;
}

</style>
